






























import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/header/MHeader.vue";
import Footer from "@/components/Footer.vue";
import AdminsApi from "@/services/AdminsApi";
import TooltipModule from "@/store/tooltip";
import logger from "@/lib/log/logger";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class MRegister extends Vue {
  private async mounted() {
    // 本登録トークン取得
    const { token } = this.$route.query;
    if (!token) {
      // MPreRegisterに戻る
      this.$router.push({ name: "MPreRegister" });
    }
    // 本登録トークンを用いてAPI instance生成
    const adminsRes = AdminsApi.createInstance(token as string);
    try {
      // アカウント情報の取得
      const AdminRes = await adminsRes.createAdmin();
      if (!AdminRes?.data?.data?.admin) {
        return;
      }
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      // エラーが起きた際はMPreRegisterに戻る
      this.$router.push({ name: "MPreRegister" });
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }
}
